import { checkDeadlinePassed } from '../../components/special/checkDeadlinePassed';

// the projects of the user, each with the tasks assigned to them
export const OWN_PROJECTS_PATH = 'projects/own/with-tasks';

// every running project of the user, for the project filter of the pool
export const POOL_PROJECTS_PATH = 'projects/own?status[eq]=0&perPage=500';

const isOpenTask = (task) => !task.status;

const isOverdueTask = (task) =>
  isOpenTask(task) &&
  Boolean(task.deadline) &&
  checkDeadlinePassed(task.deadline);

// puts a task into the tasks of its project, replacing it if it is already there
export function addTaskToProject(payload, projectId, task) {
  return {
    ...payload,
    data: (payload.data || []).map((project) => {
      if (project.id !== projectId) return project;

      const tasks = project.tasks || [];
      const exists = tasks.some((item) => item.id === task.id);

      return {
        ...project,
        tasks: exists
          ? tasks.map((item) => (item.id === task.id ? task : item))
          : [...tasks, task],
      };
    }),
  };
}

// takes a task out of the tasks of its project
export function removeTaskFromProject(payload, projectId, taskId) {
  return {
    ...payload,
    data: (payload.data || []).map((project) =>
      project.id === projectId
        ? {
            ...project,
            tasks: (project.tasks || []).filter((item) => item.id !== taskId),
          }
        : project,
    ),
  };
}

// counters of the tasks a project brought with it
export function projectTaskStats(tasks) {
  // a default only covers undefined, and the API may well send null
  const list = tasks || [];
  const open = list.filter(isOpenTask);

  return {
    total: list.length,
    open: open.length,
    done: list.length - open.length,
    overdue: list.filter(isOverdueTask).length,
    openScore: open.reduce((sum, task) => sum + (task.effortScore || 0), 0),
  };
}

// what the user has on their plate, plus how much is up for grabs
export function overviewStats(projects = [], poolCount = 0) {
  const totals = projects.reduce(
    (sum, project) => {
      const stats = projectTaskStats(project.tasks);

      return {
        open: sum.open + stats.open,
        done: sum.done + stats.done,
        overdue: sum.overdue + stats.overdue,
        openScore: sum.openScore + stats.openScore,
        projectsWithOpen: sum.projectsWithOpen + (stats.open ? 1 : 0),
      };
    },
    { open: 0, done: 0, overdue: 0, openScore: 0, projectsWithOpen: 0 },
  );

  return { ...totals, pool: poolCount };
}
